import { useQuery } from "@tanstack/react-query"
import { UserDetail } from "../app/models/User"
import { digitalManagerApi } from "../services/api"

export function useUsers(onlyWithBackofficeAccess: boolean) {
  const { data: usersList = [], isLoading: isLoadingUsers } = useQuery({
    queryKey: ["users", onlyWithBackofficeAccess],
    queryFn: () =>
      digitalManagerApi
        .get<UserDetail[]>("/users", { params: { onlyWithBackofficeAccess } })
        .then((r) => r.data),
  })

  return {
    usersList,
    isLoadingUsers,
  }
}
